import { createContext, useContext, useState, useEffect } from 'react'
import type { ReactNode } from 'react'

interface WaitlistContextType {
  count: number
  spotsLeft: number
  incrementCount: () => void
  isLoading: boolean
}

const WaitlistContext = createContext<WaitlistContextType | undefined>(undefined)

const INITIAL_COUNT = 0
const TOTAL_FOUNDING_SPOTS = 500

export function WaitlistProvider({ children }: { children: ReactNode }) {
  const [count, setCount] = useState(INITIAL_COUNT)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    // Simulate loading waitlist count from backend
    // In production, this would fetch from your API
    const timer = setTimeout(() => {
      // Start from 0 and let it grow organically
      setCount(INITIAL_COUNT)
      setIsLoading(false)
    }, 500)

    return () => clearTimeout(timer)
  }, [])

  const incrementCount = () => {
    setCount(prev => prev + 1)
  }

  const spotsLeft = Math.max(0, TOTAL_FOUNDING_SPOTS - count)

  return (
    <WaitlistContext.Provider value={{ count, spotsLeft, incrementCount, isLoading }}>
      {children}
    </WaitlistContext.Provider>
  )
}

export function useWaitlist() {
  const context = useContext(WaitlistContext)
  if (!context) {
    throw new Error('useWaitlist must be used within a WaitlistProvider')
  }
  return context
}
